import React, {FC, memo} from 'react';
import LegalDocument from '@/app/components/legal_document/widget';

const PrivacyPolicy: FC = () => {
  return <LegalDocument documentType="privacyPolicy" />;
};

export default memo(PrivacyPolicy);